import React from 'react';
import Button, { ButtonLink } from '@platform-ui/button';
import cn from 'classnames';
import styles from './NotificationBaseButtons.module.css';
const NotificationBaseButtons = props => {
  return props.actionText || props.cancelText ? /*#__PURE__*/React.createElement("div", {
    className: cn(styles.buttonGroup, {
      [styles[`buttonGroup_size_${props.size}`]]: true
    })
  }, !!props.actionText && /*#__PURE__*/React.createElement(Button, {
    theme: "outlineOnLight",
    size: props.size === 's' ? 'xs' : 's',
    onClick: props.onActionConfirm
  }, props.actionText), !!props.cancelText && /*#__PURE__*/React.createElement(ButtonLink, {
    theme: "clear",
    size: "s",
    pseudo: true,
    onClick: props.onCancel
  }, props.cancelText)) : null;
};
export default NotificationBaseButtons;